import React, {useState} from 'react';
import {Row, Col} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleRight, faAngleLeft} from '@fortawesome/free-solid-svg-icons';
import './BankTable.css';
import {MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody} from 'mdb-react-ui-kit';
import {Button} from 'react-bootstrap';
import {updateWeek} from '../../../services/MadricService';
import Spinner from '../../Spinner/Spinner';
import {Dropdown} from 'react-bootstrap';

/**
 * Permet de faire afficher les heures en banques
 * @param {*} props props
 * @return {JSX}
 */
function BankTable(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [heureRegulierH, setHeureRegulierH] = useState(props.banque.regular_hourH);
  const [heureRegulierM, setHeureRegulierM] = useState(props.banque.regular_hourM);
  const [currentHeureBanqueTotalH, setCurrentHeureBanqueTotalH] = useState(props.banque.total_bank_hourH);
  const [currentHeureBanqueTotalM, setCurrentHeureBanqueTotalM] = useState(props.banque.total_bank_hourM);
  const [heureBanquePayeH, setHeureBanquePayeH] = useState(props.banque.heure_banque_payeH);
  const [heureBanquePayeM, setHeureBanquePayeM] = useState(props.banque.heure_banque_payeM);
  const [note, setNote] = useState(props.banque.note);
  const [errors, setErrors] = useState({});

  const [isLoading, setIsLoading] = useState(false);


  /**
   * Permet d'ouvrir le modal
   */
  function openModal() {
    document.getElementById('navbar').classList.add('navbar-hidden');
    document.body.classList.add('modal-open');
    setHeureBanquePayeH(props.banque.heure_banque_payeH);
    setHeureBanquePayeM(props.banque.heure_banque_payeM);
    setCurrentHeureBanqueTotalH(props.banque.total_bank_hourH);
    setCurrentHeureBanqueTotalM(props.banque.total_bank_hourM);
    setHeureRegulierH(props.banque.regular_hourH);
    setHeureRegulierM(props.banque.regular_hourM);
    setNote(props.banque.note);
    setIsModalOpen(true);
  }

  const closeModal = () => {
    setErrors({});
    document.getElementById('navbar').classList.remove('navbar-hidden');
    document.body.classList.remove('modal-open');
    setIsModalOpen(false);
  };

  /**
   * Permet d'envoyer le formulaire
   */
  async function handleSubmit() {
    setErrors({});
    const errorsForm = {};

    if (heureRegulierH === '') {
      errorsForm.heureRegulierH = 'Heures de la semaine (régulier) est requis';
    }

    if (heureRegulierM === '') {
      errorsForm.heureRegulierM = 'Minutes de la semaine (régulier) est requis';
    }

    if (currentHeureBanqueTotalH === '') {
      errorsForm.currentHeureBanqueTotalH = 'Total heures en banque est requis';
    }

    if (currentHeureBanqueTotalM === '') {
      errorsForm.currentHeureBanqueTotalM = 'Total minutes en banque est requis';
    }

    if (heureBanquePayeH === '') {
      errorsForm.heureBanquePayeH = 'Heures en banque payé est requis';
    }

    if (heureBanquePayeM === '') {
      errorsForm.heureBanquePayeM = 'Minutes en banque payé est requis';
    }

    if ( parseInt(heureRegulierM) < 0) {
      errorsForm.heureRegulierM2 = 'Les minutes ne peuvent pas être négative';
    }

    if ( parseInt(currentHeureBanqueTotalM) < 0) {
      errorsForm.currentHeureBanqueTotalM2 = 'Les minutes ne peuvent pas être négative';
    }

    if (parseInt(heureBanquePayeM) < 0) {
      errorsForm.heureBanquePayeM2 = 'Les minutes ne peuvent pas être négative';
    }

    if ( parseInt(heureRegulierH) < 0) {
      errorsForm.heureRegulierH2 = 'Heures de la semaine (régulier) ne peut pas être négative';
    }

    if (Object.keys(errorsForm).length > 0) {
      setErrors(errorsForm);
    } else {
      setIsLoading(true);
      setErrors({});
      await updateWeek( parseInt(heureRegulierH), parseInt(heureRegulierM), parseInt(currentHeureBanqueTotalH), parseInt(currentHeureBanqueTotalM), parseInt(heureBanquePayeH), parseInt(heureBanquePayeM), parseInt(props.week), note, props.selectedUser);
      props.banque.note = note;
      props.banque.regular_hourH = heureRegulierH;
      props.banque.regular_hourM = heureRegulierM;
      props.banque.total_bank_hourH = currentHeureBanqueTotalH;
      props.banque.total_bank_hourM = currentHeureBanqueTotalM;
      props.banque.heure_banque_payeH = heureBanquePayeH;
      props.banque.heure_banque_payeM = heureBanquePayeM;
      props.fetchDataWhileOnPage(props.selectedUser);
      setIsLoading(false);
      closeModal();
    }
  }

  return (
    <div className="banktable-container">
      {isLoading && <Spinner />}
      {isModalOpen && (
        <MDBContainer className="modal" >
          <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content">
            <MDBCol col="12">
              <MDBCard
                className="bg-dark text-white my-5 mx-auto align-items-center"
                style={{borderRadius: '1rem', maxWidth: '800px'}}>
                <span className="banktable-close" onClick={closeModal} style={{marginRight: '20px'}}>
                &times;
                </span>
                <h2 className="fw-bold mb-2 text-uppercase">Heures de la semaine</h2>
                <MDBCardBody className="mx-auto w-100 banktable-padding" >
                  <label className="text-white">Heures de la semaine &#40;régulier&#41;:</label>
                  <div className="sameLineContainer">
                    <div className="sameLine">
                      <input
                        type="tel"
                        min="0"
                        className="form-control"
                        value={isNaN(parseInt(heureRegulierH)) ? '' : parseInt(heureRegulierH)}
                        onChange={(event) => setHeureRegulierH(event.target.value)} />
                    </div>
                    <div className="sameLine" style={{fontSize: '20px', paddingLeft: '5px', paddingRight: '15px'}}>
                    h
                    </div>
                    <div className="sameLine">
                      <input
                        min="0"
                        type="tel"
                        className="form-control"
                        value={isNaN(parseInt(heureRegulierM)) ? '' : parseInt(heureRegulierM)}
                        onChange={(event) => setHeureRegulierM(event.target.value)} />
                    </div>
                    <div className="sameLine" style={{fontSize: '20px', paddingLeft: '5px'}}>
                    min
                    </div>

                  </div>

                  <div className='banktable-bottom'>
                    <div>
                      {errors && errors.heureRegulierH && (
                        <span className="error">{errors.heureRegulierH}</span>
                      )}
                    </div>
                    <div>
                      {errors && errors.heureRegulierM && (
                        <span className="error">{errors.heureRegulierM}</span>
                      )}
                    </div>
                    <div>
                      {errors && errors.heureRegulierM2 && (
                        <span className="error">{errors.heureRegulierM2}</span>
                      )}
                    </div>
                    <div>
                      {errors && errors.heureRegulierH2 && (
                        <span className="error">{errors.heureRegulierH2}</span>
                      )}
                    </div>
                  </div>
                  <label className="text-white">Heures en banque payé:</label>
                  <div className="sameLineContainer">
                    <div className="sameLine">
                      <input
                        type="tel"
                        className="form-control"
                        value={isNaN(parseInt(heureBanquePayeH)) ? '' : parseInt(heureBanquePayeH)}
                        onChange={(event) => setHeureBanquePayeH(event.target.value)} />
                    </div>
                    <div className="sameLine" style={{fontSize: '20px', paddingLeft: '5px', paddingRight: '15px'}}>
                    h
                    </div>
                    <div className="sameLine">
                      <input
                        min="0"
                        type="tel"
                        className="form-control"
                        value={isNaN(parseInt(heureBanquePayeM)) ? '' : parseInt(heureBanquePayeM)}
                        onChange={(event) => setHeureBanquePayeM(event.target.value)} />
                    </div>
                    <div className="sameLine" style={{fontSize: '20px', paddingLeft: '5px'}}>
                    min
                    </div>
                  </div>
                  <div className='banktable-bottom'>
                    <div>
                      {errors && errors.heureBanquePayeH && (
                        <span className="error">{errors.heureBanquePayeH}</span>
                      )}
                    </div>
                    <div>
                      {errors && errors.heureBanquePayeM && (
                        <span className="error">{errors.heureBanquePayeM}</span>
                      )}
                    </div>
                    <div>
                      {errors && errors.heureBanquePayeM2 && (
                        <span className="error">{errors.heureBanquePayeM2}</span>
                      )}
                    </div>
                    <div>
                    </div>
                  </div>
                  <label className="text-white">Total heures en banque</label>
                  <div className="sameLineContainer">
                    <div className="sameLine">
                      <input
                        type="text"
                        className="form-control"
                        value={currentHeureBanqueTotalH}
                        onChange={(event) => {
                          const input = event.target.value;
                          // Check if the input is a valid integer before updating the state
                          if (/^-?\d*$/.test(input)) {
                            setCurrentHeureBanqueTotalH(input);
                          }
                        }}
                      />

                    </div>
                    <div className="sameLine" style={{fontSize: '20px', paddingLeft: '5px', paddingRight: '15px'}}>
                    h
                    </div>
                    <div className="sameLine">
                      <input
                        min="0"
                        type="tel"
                        className="form-control"
                        value={isNaN(parseInt(currentHeureBanqueTotalM)) ? '' : parseInt(currentHeureBanqueTotalM)}
                        onChange={(event) => setCurrentHeureBanqueTotalM(event.target.value)} />
                    </div>
                    <div className="sameLine" style={{fontSize: '20px', paddingLeft: '5px'}}>
                    min
                    </div>
                  </div>
                  <div className='banktable-bottom'>
                    <div>
                      {errors && errors.currentHeureBanqueTotalH && (
                        <span className="error">{errors.currentHeureBanqueTotalH}</span>
                      )}
                    </div>
                    <div>
                      {errors && errors.currentHeureBanqueTotalM && (
                        <span className="error">{errors.currentHeureBanqueTotalM}</span>
                      )}
                    </div>
                    <div>
                      {errors && errors.currentHeureBanqueTotalM2 && (
                        <span className="error">{errors.currentHeureBanqueTotalM2}</span>
                      )}
                    </div>
                    <div>
                    </div>
                  </div>
                  <div className="mb-4">
                    <label className="text-white">Note:</label>
                    <textarea
                      className="form-control banktable-padding-bottom"
                      value={note}
                      onChange={(event) => setNote(event.target.value)} />
                  </div>
                  <Button
                    className="px-5"
                    color="white"
                    size="lg"
                    style={{
                      color: 'white',
                      fontSize: 'calc(10px + 2vmin)', // responsive font size
                      backgroundColor: '#363E46',
                      border: 'none',
                      width: '100%', // make the button responsive
                    }}
                    onClick={handleSubmit}>
                  Enregistrer
                  </Button>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      )}

      <div className="banktable-week d-flex justify-content-between align-items-center">
        <div>{props.banque.week}</div>
        <div className="d-flex justify-content-between">
          <div>
            <button
              className="banktable-pagination-button banktable-pagination-button-left"
              onClick={() => props.previous()}
              >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>
            <button
              className="banktable-pagination-button"
              onClick={() => props.next()}
              disabled={props.week === 0}>
              <FontAwesomeIcon icon={faAngleRight} />
            </button>
          </div>
        </div>
      </div>
      <div className="banktable-wrapper">
        <div className="banktable-table">
          <div className="banktable-table">
            <Row className="banktable-row banktable-row-cell-click">
              <Col md={6} className="banktable-cell banktable-cell-click" style={{fontSize: '20px'}}>
                {localStorage.getItem('admin') === '1' ?
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                <Dropdown style={{marginTop: '7px'}}>
                  <Dropdown.Toggle
                    className="chantierheure-dropdown"
                    style={{
                      all: 'unset',
                      backgroundColor: 'white',
                      color: 'black',
                      cursor: 'pointer',
                    }}>
                    {props.selectedUser.label}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {props.users.map((user, index) => {
                      return <Dropdown.Item key={index} onClick={() => props.fetchDataWhileOnPage(user)}>{user.label}</Dropdown.Item>;
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div> : ''}
              </Col>

              <Col
                md={6}
                className="banktable-cell banktable-cell-click"
                data-title="Facture">
                {props.week <= 1 ?
                <button
                  className="banktable-pagination-button-modifier"
                  onClick={openModal}>
                Modifier
                </button> : ''}

              </Col>
            </Row>
            <Row className="banktable-row banktable-row-cell-click">
              <Col md={6} className="banktable-cell banktable-cell-click">
                {' '}
                Heures en banque accumulées &#40;semaine précédente&#41;:{' '}
                {props.banque.previous_bank_hour}
              </Col>
              <Col
                md={6}
                className="banktable-cell banktable-cell-click"
                data-title="Facture">
                Nb heures semaine en cours: {props.banque.total_hour}{' '}
              </Col>
            </Row>
            <Row className="banktable-row banktable-row-cell-click">
              <Col md={6} className="banktable-cell banktable-cell-click">
                Heures en banque payé: <span style={{fontWeight: '600'}}>{props.banque.heure_banque_payeH}h{props.banque.heure_banque_payeM === undefined ? '' : props.banque.heure_banque_payeM.toString().padStart(2, '0')}</span>
              </Col>
              <Col
                md={6}
                className="banktable-cell banktable-cell-click"
                data-title="Facture">
                Heures de la semaine &#40;régulier&#41;:{' '}
                <span style={{fontWeight: '600'}}>{props.banque.regular_hourH}h{props.banque.regular_hourM === undefined ? '' : props.banque.regular_hourM.toString().padStart(2, '0')}</span>
              </Col>
            </Row>
            <Row className="banktable-row banktable-row-cell-click">
              <Col md={6} className="banktable-cell banktable-cell-click">
                Suggestion:{' '}
                {props.banque.current_bank_hour_suggestion}{' '}|
                Total heures en banque: {' '}
                <span style={{fontWeight: '600'}}>{props.banque.total_bank_hourH}h{props.banque.total_bank_hourM === undefined ? '' : props.banque.total_bank_hourM.toString().padStart(2, '0')}</span>
              </Col>
              <Col md={6} className="banktable-cell banktable-cell-click">
                Heures accumulé semaine en cours:{' '}
                {props.banque.current_bank_hour_added}
              </Col>
            </Row>
          </div>
          <Row className="banktable-row banktable-row-cell-click banktable-note">
            <Col
              md={12}
              className="banktable-cell banktable-cell-click banktable-col-lastchild banktable-note"
              data-title="Facture">
              Note: {props.banque.note}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default BankTable;
